import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type ExportMetadataEventsSubscriptionVariables = Types.Exact<{ [key: string]: never; }>;


export type ExportMetadataEventsSubscription = { __typename?: 'Subscription', exportMetadataEvents: { __typename?: 'ExportMetadataChangedPayload', reason: Types.ExportMetadataChangeReason } };


export const ExportMetadataEvents = /*#__PURE__*/ gql`
    subscription ExportMetadataEvents {
  exportMetadataEvents {
    reason
  }
}
    ` as unknown as DocumentNode<ExportMetadataEventsSubscription, ExportMetadataEventsSubscriptionVariables>;

          

          export const useExportMetadataEventsSubscription = (options?:SubscriptionHookOptions<ExportMetadataEventsSubscription, ExportMetadataEventsSubscriptionVariables>) => useSubscription(ExportMetadataEvents, options);

          

          export type ExportMetadataEventsSubscriptionOptions = SubscriptionHookOptions<ExportMetadataEventsSubscription, ExportMetadataEventsSubscriptionVariables>;

          

          export type ExportMetadataEventsSubscriptionResult = ReturnType<typeof useExportMetadataEventsSubscription>;

          
